import { MouseEventHandler } from "react";
import { useNavigate } from "react-router-dom";
import { IAPIObjective } from "redux/configuration/configuration.interface";
import { track } from "utils";
import { Routes, ROUTES } from "utils/constants/router";
import { MyliEventType } from "utils/types/event";

export const useMarketActionCTA = (
  hideModal: () => void,
  marketActionUrl?: string,
  marketActionType?: IAPIObjective
): MouseEventHandler => {
  const navigate = useNavigate();

  return () => {
    hideModal();

    if (marketActionType) {
      track(MyliEventType.MARKET_ACTION, {
        objective: marketActionType,
      });
    }

    navigate(`../${ROUTES.get(Routes.game).path}`);

    if (marketActionUrl) {
      window.open(marketActionUrl, "_blank");
    }
  };
};
